// extracted by mini-css-extract-plugin
module.exports = {"spinnerHolder":"WebshopFilter_spinnerHolder__1Wz0n"};